import React from 'react';
import { history } from '../store/index';
import { store } from '../../NextApp';
import { generateQueryString } from "../../util/Api";

import {
    CLEAR_FUEL_REPORT_DATA,
    CREATE_FUEL_SUCCESS,
    FETCH_ASSET_FILTER_SUCCESS, FETCH_ASSET_FUEL_SUCCESS,
    FETCH_FUEL_FILTER_DATA_SUCCESS, FETCH_FUEL_MILEAGE_REPORT_DATA_SUCCESS,
    FETCH_FUEL_REFUEL_REPORT_DATA_SUCCESS,
    FETCH_FUEL_REPORT_DATA_SUCCESS,
    FETCH_FUEL_STATUS_DATE_SUCCESS,
    FETCH_FUEL_SUCCESS, FETCH_FUEL_SUMMERY_REPORT_DATA_SUCCESS,
    FETCH_BOWSER_TRANSACTION_REPORT_DATA_SUCCESS,
    FETCH_BOWSER_REPORT_DATA_SUCCESS,
    FETCH_MOTORABLE_ASSET_SUCCESS,
    GET_FUEL_SUCCESS,
    SAVE_FUEL_QUERY
} from "../../constants/ActionTypes";

import axios from 'util/Api'
import { fetchError, fetchFilter, fetchStart, fetchSubElementFilter, fetchSuccess, fetchDataStart, fetchDataSuccess, fetchDataError } from "./Common";
import { getUser } from "./Auth";
import { Icon, message, notification } from "antd";
import { arrayToCSV, downloadCSV, fuelSvgIcon, getErrorMessage, downloadJSONFile } from "../../util/methods";
import * as _ from "lodash";
import moment from 'moment';

const isHttpUrl = (value) => typeof value === 'string' && /^https?:\/\//i.test(value);

const getExistingPhotoUrl = (photo) => {
    if (!photo) return null;
    if (isHttpUrl(photo.uid)) return photo.uid;
    if (isHttpUrl(photo.url)) return photo.url;
    return null;
};

export const getResourceSuccess = ({ data, count }) => {
    return {
        type: GET_FUEL_SUCCESS,
        data,
        count
    };
};

export const saveResourceQuery = (query) => {
    return {
        type: SAVE_FUEL_QUERY,
        query
    };
};

export const createResourceSuccess = ({ data }) => {
    return {
        type: CREATE_FUEL_SUCCESS,
        data
    };
};

export const fetchResourceSuccess = ({ data }) => {
    return {
        type: FETCH_FUEL_SUCCESS,
        data
    };
};

export const fetchAssetFuelsSuccess = ({ data }) => {
    return {
        type: FETCH_ASSET_FUEL_SUCCESS,
        data
    };
};

export const fetchFuelReportDataSuccess = (data) => {
    return {
        type: FETCH_FUEL_REPORT_DATA_SUCCESS,
        data,
    };
};

export const getFuelMileageReportDataSuccess = (data) => {
    return {
        type: FETCH_FUEL_MILEAGE_REPORT_DATA_SUCCESS,
        data,
    };
};

export const getFuelSummeryReportDataSuccess = (data) => {
    return {
        type: FETCH_FUEL_SUMMERY_REPORT_DATA_SUCCESS,
        data,
    };
};

export const getRefuelReportDataSuccess = (data) => {
    return {
        type: FETCH_FUEL_REFUEL_REPORT_DATA_SUCCESS,
        data,
    };
};

export const clearReportData = () => {
    return {
        type: CLEAR_FUEL_REPORT_DATA
    };
};

export const getFilterSuccess = (assets) => {
    return {
        type: FETCH_ASSET_FILTER_SUCCESS,
        assets,
    };
};

export const getFuelFormFilter = () => {
    return async dispatch => {
        dispatch(fetchStart());

        const assets = await axios.get(`/asset`);
        // const subLocations = await axios.get(`/client`);
        // const spareParts = await axios.get(`/spare-part`);
        // const sparePartTypes = await axios.get(`/spare-part-type`);
        //console.log(assets);
        if (assets) {
            dispatch(getFilterSuccess(assets.data));
            dispatch(fetchSuccess());
        } else {
            message.error('Loading data missing!');
            dispatch(fetchError('Loading data missing!'));
            console.log("Error****:", 'Loading data missing!');
        }
    };
}

/**
 * Get fuel summary report with flexible time period grouping
 * @param {Object} payload - Request payload for the fuel summary report
 * @param {string} timePeriod - Time period for grouping: 'daily', 'weekly', 'monthly', 'quarterly', or 'yearly' (default: 'daily')
 * @returns {Function} Redux thunk action
 */
export const getFuelSummeryReport = (payload, timePeriod = 'daily') => {
    return async (dispatch) => {

        dispatch(fetchStart());
        // console.log(payload)
        try {
            const response = await axios.post(`/fuel/summery-report`, payload);
            // const normaldata = normalizeReportData(response.data);
            // console.log(response)
            const processedData = processFuelSummery(response.data, timePeriod);
            // console.log('processedData', processedData)
            dispatch(getFuelSummeryReportDataSuccess(processedData));
            dispatch(fetchSuccess());
        } catch
        (error) {
            console.log("Error****:", error);
            message.error(getErrorMessage(error));
            dispatch(fetchError(getErrorMessage(error)));
        }
    }
}

export const getRefuelReport = (payload) => {
    return async (dispatch) => {

        dispatch(fetchStart());
        // console.log(payload)
        try {
            const response = await axios.post(`/fuel/refuel-report`, payload);
            // const normaldata = normalizeReportData(response.data);
            // console.log(response)
            const processedData = processRefuelReport(response.data);
            // console.log(processedData)
            dispatch(getRefuelReportDataSuccess(processedData));
            dispatch(fetchSuccess());
        } catch
        (error) {
            console.log("Error****:", error);
            message.error(getErrorMessage(error));
            dispatch(fetchError(getErrorMessage(error)));
        }
    }
}

const processRefuelReport = (dataRecords) => {
    return dataRecords;
}

/**
 * Process fuel summary data with flexible time period grouping
 * @param {Array} dataRecords - Array of fuel records to process
 * @param {string} timePeriod - Time period for grouping: 'daily', 'weekly', 'monthly', 'quarterly', or 'yearly'
 * @returns {Array} Processed fuel summary data grouped by time period, location, sublocation, and fuel type
 */
const processFuelSummery = (dataRecords, timePeriod = 'daily') => {
    function calculateTotal(records, main = false) {
        // const records = data.records;
        const quantity = records.reduce((total, record) => total + record.quantity, 0);
        const dateFrom = new Date(records[0].date);
        const dateTo = new Date(records[records.length - 1].date);

        const location = records[0].location && records[0].location.name;

        const typeOfFuel = records[0].typeOfFuel && records[0].typeOfFuel.name;
        let groupedRecords = _.groupBy(records, 'subLocation.name');

        const subLocation = Object.keys(groupedRecords).length === 1 ? records[0].subLocation && records[0].subLocation.name : '';

        return {
            key: `${main ? 'p' : 's'}-${records[0]._id}`,
            dateFrom,
            dateTo,
            location,
            subLocation,
            typeOfFuel,
            quantity
        };
    }

    // Helper function to get time period key based on the timePeriod parameter
    const getTimePeriodKey = (date) => {
        const momentDate = moment(date);

        switch (timePeriod.toLowerCase()) {
            case 'yearly':
                // Group by year - format: YYYY (e.g., 2024)
                return momentDate.format('YYYY');
            case 'quarterly':
                // Group by quarter - format: YYYY-Q (e.g., 2024-Q1)
                return momentDate.format('YYYY-[Q]Q');
            case 'monthly':
                // Group by month - format: YYYY-MM (e.g., 2024-01)
                return momentDate.format('YYYY-MM');
            case 'weekly':
                // Group by week (Monday to Sunday) - format: YYYY-WW (e.g., 2024-W01)
                return momentDate.format('YYYY-[W]WW');
            case 'daily':
            default:
                // Group by day - format: YYYY-MM-DD (e.g., 2024-01-15)
                return momentDate.format('YYYY-MM-DD');
        }
    };

    // console.log(dataRecords)
    return dataRecords.map(doc => {

        // Group records by time period, location, sublocation, and fuel type
        let groupedPrimaryRecords = _.groupBy(doc.records, record => {
            const timePeriodKey = getTimePeriodKey(record.date);
            return `${timePeriodKey}_${record.location && record.location._id}_${record.subLocation && record.subLocation._id}_${record.typeOfFuel && record.typeOfFuel._id}`
        });

        // console.log(groupedPrimaryRecords)
        let combinedRecords = _.map(groupedPrimaryRecords, (records) => {
            let totalQuantity = _.sumBy(records, 'quantity');
            return {
                _id: records[0]._id,
                date: records[0].date,
                location: records[0].location,
                subLocation: records[0].subLocation,
                typeOfFuel: records[0].typeOfFuel,
                quantity: totalQuantity
            };
        });
        // console.log(combinedRecords);

        const primary = calculateTotal(combinedRecords, true)

        const children = [];
        let groupedRecords = _.groupBy(combinedRecords, 'subLocation.name');
        // console.log(groupedRecords) // {"sub1" : [], "sub2":[]}
        // if (Object.keys(groupedRecords).length > 1) {
        Object.keys(groupedRecords).map(sub => {
            children.push({
                ...calculateTotal(groupedRecords[sub]), children: groupedRecords[sub].map(child => {
                    return {
                        key: child._id,
                        dateFrom: '',
                        dateTo: child.date,
                        location: child.location && child.location.name,
                        subLocation: child.subLocation && child.subLocation.name,
                        typeOfFuel: child.typeOfFuel && child.typeOfFuel.name,
                        quantity: child.quantity || 0
                    }
                })
            })
        })
        // }
        if (children.length === 1)
            return { ...primary, children: children[0]['children'] }
        else
            return { ...primary, children }
    })
}

export const getFuelMileageReportData = (payload) => {
    return async (dispatch) => {

        dispatch(fetchStart());
        // console.log('payload', payload)
        try {
            const response = await axios.post(`/fuel/mileage-report`, payload);
            // const normaldata = normalizeReportData(response.data);
            // console.log('response - ', response.data)
            const processedData = processFuelConsume(response.data, payload);
            // console.log('processedData - ', processedData) // is a array [{key:[]}]
            if (payload && payload.asset && !payload.assets) {
                // console.log(processedData.filter(data => data[Object.keys(data)[0]] && data[Object.keys(data)[0]].length > 0))
                dispatch(getFuelMileageReportDataSuccess(processedData.filter(data => data[Object.keys(data)[0]] && data[Object.keys(data)[0]].length > 0)));
            } else {
                dispatch(getFuelMileageReportDataSuccess(processedData))
            }
            dispatch(fetchSuccess());
        } catch
        (error) {
            console.log("Error****:", error);
            message.error(getErrorMessage(error));
            dispatch(fetchError(getErrorMessage(error)));
        }
    }
}

const processFuelConsume = (data, payload) => {

    const groupedData = data.reduce((acc, curr) => {
        if (!acc[curr.asset._id]) {
            acc[curr.asset._id] = [];
        }
        acc[curr.asset._id].push(curr);
        return acc;
    }, {});
    // console.log('groupedData', groupedData)

    return Object.keys(groupedData).map(assetId => {
        const sampleData = [...groupedData[assetId]];

        // Sort the sample data array by date        
        sampleData.sort((a, b) => new Date(a.date) - new Date(b.date));
        // console.log('sorted ', sampleData)
        // Find index of first full tank record
        const firstFullTankIndex = sampleData.findIndex(record => record.isFullTank)
        // console.log('firstFullTankIndex ', firstFullTankIndex)
        // Remove all records before first full tank if found
        // Split data into two arrays based on firstFullTankIndex
        const beforeFullTank = firstFullTankIndex > 0 ? sampleData.slice(0, firstFullTankIndex) : []
        // const fromFullTank = firstFullTankIndex >= 0 ? sampleData.slice(firstFullTankIndex) : sampleData


        if (firstFullTankIndex > 0) {
            sampleData.splice(0, firstFullTankIndex)
        }

        // console.log('beforeFullTank ', beforeFullTank)
        // console.log('fromFullTank ', fromFullTank)
        // console.log('sampleData ', sampleData)

        const mileageNamesSet = new Set();

        // Iterate over all records to collect unique mileage names from all records
        sampleData.forEach(record => {
            if (record.mileage && Array.isArray(record.mileage)) {
                record.mileage.forEach(entry => {
                    mileageNamesSet.add(entry.name);
                });
            }
        });
        // Convert the set to an array of unique mileage names
        const mileageNamesArray = Array.from(mileageNamesSet);
        // console.log(mileageNamesArray)

        let totalQuantity = 0;
        const totalConsumed = [];
        const totalMileage = [];
        const totalMileagePerMeter = [];

        // Initialize variables to store previous readings
        let previousReading = [];
        mileageNamesArray.forEach((unit, i) => {
            previousReading[i] = {
                name: unit,
                currentValue: 0,
                value: 0
            }
            totalConsumed[i] = {
                name: unit,
                currentValue: 0,
                value: 0
            }
            totalMileage[i] = {
                name: unit,
                currentValue: 0,
                value: 0
            }
            totalMileagePerMeter[i] = {
                name: unit,
                currentValue: 0,
                value: 0
            }
        })

        let prevIsFullTank = false;
        let prevQuantity = 0;
        return {

            [assetId]: [...beforeFullTank.map(entry => {
                const currentReading = [];
                mileageNamesArray && (mileageNamesArray || []).forEach((unit, i) => {
                    const reading = entry.mileage.find(mil => mil.name === mileageNamesArray[i]) && entry.mileage.find(mil => mil.name === mileageNamesArray[i]).reading;
                    const effectiveReadingRecord = entry.mileage.find(mil => mil.name === mileageNamesArray[i]) && entry.mileage.find(mil => mil.name === mileageNamesArray[i]).meterReadingRecord;
                    const value = effectiveReadingRecord && effectiveReadingRecord.calculatedReading ? effectiveReadingRecord.calculatedReading : reading;
                    currentReading[i] = {
                        name: unit,
                        value: Math.round(value * 100) / 100,
                        currentValue: reading
                    }
                })
                return {
                    ...entry,
                    currentReading
                }
            }),
            ...sampleData.map((entry, index) => {
                // console.log(entry.mileage)
                const quantity = Math.round((entry.quantity || 0) * 100) / 100;
                if (index !== 0)
                    totalQuantity += quantity;

                // const kmReading = entry.mileage.find(entry => entry.name === "KM").reading;
                // const hourReading = entry.mileage.find(entry => entry.name === "HOUR").reading;

                const currentReading = [];
                const consumedReading = [];
                const consumedMileage = [];
                const consumedMileagePerMeter = [];
                let quantityConsumed = 0;

                if (entry.isFullTank) {
                    quantityConsumed = quantity;
                    // Look backwards through the array until we find a full tank or reach the start
                    if (!prevIsFullTank) {
                        let nonFullTankTotal = 0;
                        // Look backwards through the array until we find a full tank or reach the start
                        for (let j = index - 1; j >= 0; j--) {
                            if (sampleData[j].isFullTank) {
                                break;
                            }
                            nonFullTankTotal += (sampleData[j].quantity || 0);
                        }
                        quantityConsumed += nonFullTankTotal;
                    }
                }

                mileageNamesArray && (mileageNamesArray || []).forEach((unit, i) => {
                    const reading = entry.mileage.find(mil => mil.name === mileageNamesArray[i]) && entry.mileage.find(mil => mil.name === mileageNamesArray[i]).reading;
                    const effectiveReadingRecord = entry.mileage.find(mil => mil.name === mileageNamesArray[i]) && entry.mileage.find(mil => mil.name === mileageNamesArray[i]).meterReadingRecord;
                    const value = effectiveReadingRecord && effectiveReadingRecord.calculatedReading ? effectiveReadingRecord.calculatedReading : reading;
                    currentReading[i] = {
                        name: unit,
                        value: Math.round(value * 100) / 100,
                        currentValue: reading
                    }
                })

                // console.log(index, [...previousReading]);
                //
                // const currentHours = entry.Hours;
                // const currentKms = entry.Kms;
                currentReading && (currentReading || []).forEach((current, i) => {
                    // Calculate consumed hours and kilometers
                    if (entry.isFullTank) {
                        const prevReading = [...previousReading].find(prev => prev.name === current.name).value;
                        // console.log(prevReading || 0, 'prevReading')
                        // if the prev reading is not available, then set the value to 0
                        consumedReading[i] = {
                            name: current.name,
                            value: index === 0 ? 0 : Math.round(!prevReading ? 0 : (current.value - (prevReading || 0)) * 100) / 100,
                            // currentValue: current.currentValue
                        }
                    } else {
                        consumedReading[i] = {
                            name: current.name,
                            value: 0,
                            // currentValue: current.currentValue
                        }
                    }
                })

                consumedReading && (consumedReading || []).forEach((consume, i) => {
                    if (entry.isFullTank) {
                        let qty = quantityConsumed;
                        // if (!prevIsFullTank) {
                        //     // qty += prevQuantity;

                        //     let nonFullTankTotal = 0;
                        //     // Look backwards through the array until we find a full tank or reach the start
                        //     for (let j = index - 1; j >= 0; j--) {
                        //         if (sampleData[j].isFullTank) {
                        //             break;
                        //         }
                        //         nonFullTankTotal += (sampleData[j].quantity || 0);
                        //     }
                        //     qty += nonFullTankTotal;
                        // }
                        const mil = Math.round((qty ? consume.value / qty : 0) * 100) / 100;
                        consumedMileage[i] = {
                            name: consume.name,
                            value: mil,
                            // currentValue: consume.currentValue
                        }
                        const mil2 = Math.round((consume.value ? (qty || 0) / consume.value : 0) * 100) / 100;
                        consumedMileagePerMeter[i] = {
                            name: consume.name,
                            value: mil2,
                            // currentValue: consume.currentValue
                        }
                        previousReading[i] = { ...currentReading[i] }
                        totalConsumed[i] = {
                            name: consume.name,
                            value: consume.value + totalConsumed.find(con => con.name === consume.name).value,
                            // currentValue: consume.currentValue
                        }
                        totalMileage[i] = {
                            name: consume.name,
                            value: mil + totalMileage.find(con => con.name === consume.name).value,
                            // currentValue: consume.currentValue
                        }

                        totalMileagePerMeter[i] = {
                            name: consume.name,
                            value: mil2 + totalMileagePerMeter.find(con => con.name === consume.name).value,
                            // currentValue: consume.currentValue
                        }
                    } else {
                        consumedMileage[i] = {
                            name: consume.name,
                            value: 0,
                            // currentValue: consume.currentValue || 0
                        }

                        consumedMileagePerMeter[i] = {
                            name: consume.name,
                            value: 0,
                            // currentValue: consume.currentValue || 0
                        }
                    }
                })

                prevQuantity = (entry.quantity || 0); // + (!prevIsFullTank ? prevQuantity : 0);
                prevIsFullTank = entry.isFullTank || false;

                // Return the original entry with added consumed hours and kilometers
                // console.log(entry.date)
                const entryDate = moment(entry.date).startOf('day')
                const periodFrom = moment(payload.periodFrom).startOf('day')
                const periodTo = moment(payload.periodTo).startOf('day')

                if (entryDate.isSameOrAfter(periodFrom) && entryDate.isSameOrBefore(periodTo)) {

                    return {
                        ...entry,
                        meterNames: mileageNamesArray,
                        currentReading,
                        consumedReading,
                        consumedMileage,
                        consumedMileagePerMeter,
                        quantityConsumed,
                        totalQuantity,
                        totalConsumed,
                        totalMileage,
                        totalMileagePerMeter
                    };
                }
            }).filter(entry => entry)]

        }
    })
}


export const fetchFuelReportData = (payload) => {
    return async (dispatch) => {

        dispatch(fetchStart());

        try {
            const response = await axios.post(`/fuel/report`, payload);
            dispatch(fetchSuccess());
            const normaldata = normalizeReportData(response.data);
            //console.log(normaldata)
            dispatch(fetchFuelReportDataSuccess(normaldata));
        } catch
        (error) {
            message.error(error.response.data.message);
            dispatch(fetchError(error.response.data.message));
            console.log("Error****:", error.response.data.message);
        }
    }
}


const normalizeReportData = (data) => {
    return data.filter(doc => doc)
}

export const getResource = () => {
    return async (dispatch) => {

        dispatch(fetchDataStart());

        try {
            const { fuel } = store.getState();
            const { query } = fuel;
            const response = await axios.get(`/fuel?${generateQueryString(query)}`);
            // console.log('response', response.data)
            dispatch(getResourceSuccess(response.data));
            dispatch(fetchDataSuccess(response.data));
        } catch (error) {
            // message.error(error.response.data.message);
            message.error("Record not found");
            dispatch(fetchDataError(error.response.data.message));
            console.log("Error****:", error.response.data.message);
        }
    }
};

export const getResourceForDownload = (columns, filters, name) => {
    return async (dispatch) => {
        // console.log(columns)
        dispatch(fetchStart());

        try {
            const { fuel } = store.getState();
            const { query } = fuel;
            const response = await axios.get(`/fuel/download?columns=${columns}&${generateQueryString(query)}`);
            dispatch(fetchSuccess());
            const docs = (response.data || []).map(doc => {
                let meter = [];
                let isFaultyMeter = false;
                if (columns.includes('meterage')) {
                    meter = (doc.mileage || []).map(m => `${m.reading} ${m.name} `)
                    isFaultyMeter = !!(doc.mileage || []).some(m => m.isFaultyMeter)
                }
                return { ...doc, ...{ isFaultyMeter, ownerCode: doc.asset && doc.asset.ownerCode || '-', meterage: meter.join('/') } }
            })
            const str = arrayToCSV(docs, {
                ...filters, ...{
                    ownerCode: {
                        "field": "ownerCode",
                        "type": "String",
                    },

                    isFaultyMeter: {
                        "field": "meterage",
                        "type": "Boolean"

                    },
                    meterage: {
                        "field": "meterage",
                        "type": "String",
                    },
                }
            }, columns)
            downloadCSV(str, name);
        } catch (error) {
            console.log("Error****:", error);
            message.error(getErrorMessage(error)); //.response.data.message);
            dispatch(fetchError(getErrorMessage(error)));
        }
    }
};


export const createResource = (payload, redirect = true, module, subMaster = false) => {
    return async (dispatch) => {

        dispatch(fetchStart());
        try {
            let fileData = new FormData();
            payload.photos && payload.photos.map((item) => {
                fileData.append('files', item);
            });
            delete payload.photos;
            const response = await axios.post(`/fuel`, payload);
            // console.log('response', response)
            if (response && response.data && response.data.code === 202) {
                message.error(response.data.message);
            }

            if (fileData.has('files') && response && response.data) {
                fileData.append('id', response.data._id);
                const kk = await axios.post('/fuel/upload-files-in-background', fileData, { config: { headers: { 'Content-Type': 'multipart/form-data' } } })
            }

            if (response && response.data && payload.assetData) {
                // request total fuel consumption
                // console.log(response.data)
                try {
                    const totalPayload = {
                        location: payload.assetData.location,
                        periodFrom: moment(payload.date).startOf('day'),
                        periodTo: moment(payload.date).endOf('day'),
                        typeOfFuel: payload.typeOfFuel
                    }
                    const allFuelConsumptions = await axios.post(`/fuel/total-fuel-quantity`, totalPayload);
                    const total = allFuelConsumptions && allFuelConsumptions.data && allFuelConsumptions.data.length > 0 ? allFuelConsumptions.data.reduce((acc, curr) => acc + curr.quantity, 0) : 0;
                    // const FuelIcon = props => <Icon component={fuelSvgIcon} {...props} />;
                    notification.info({
                        message: 'Refuel Record Added Successfully!',
                        description:
                            <div>
                                <p style={{ margin: '4px 0' }}>Voucher Number: {response.data.voucherNo}</p>
                                <p style={{ margin: '4px 0' }}>Asset: {payload.assetData.assetCode}/ {payload.assetData.altName}/ {payload.assetData.ownerCode}</p>
                                <p style={{ margin: '4px 0' }}>Meter: {response.data.mileage
                                    .map(m => `${m.reading} ${m.name} `)
                                    .join('/')}</p>
                                <p style={{ margin: '4px 0' }}>Quantity: {response.data.quantity} ltr.</p>
                                <p style={{ margin: '4px 0' }}>Type of Fuel: {allFuelConsumptions && allFuelConsumptions.data && allFuelConsumptions.data.length > 0 ? allFuelConsumptions.data[0].typeOfFuel && allFuelConsumptions.data[0].typeOfFuel.name : ''}</p>
                                <p style={{ margin: '4px 0' }}>Location: {allFuelConsumptions && allFuelConsumptions.data && allFuelConsumptions.data.length > 0 ? allFuelConsumptions.data[0].location && allFuelConsumptions.data[0].location.name : ''}</p>
                                <p style={{ fontWeight: 'bold' }}>Total Daily Fuel: {total} ltr. {allFuelConsumptions && allFuelConsumptions.data && allFuelConsumptions.data.length > 0 ? allFuelConsumptions.data[0].typeOfFuel && allFuelConsumptions.data[0].typeOfFuel.name : ''}</p>
                            </div>,
                        duration: 5,
                        // icon: <FuelIcon />,
                        style: {
                            backgroundColor: '#f0f2f5'
                        }
                    });
                } catch (error) {
                    console.log("Error****:", error);
                }
            }
            dispatch(fetchSuccess());
            dispatch(createResourceSuccess({ data: response.data }));
            if (!redirect) {
                if (subMaster) {
                    dispatch(fetchSubElementFilter(module));
                } else {
                    dispatch(fetchFilter(module));
                }
            } else {
                history.push('/fuel');
                dispatch(getResource());
            }
        } catch (error) {
            console.log("Error****:", getErrorMessage(error));
            message.error(getErrorMessage(error));
            dispatch(fetchError(getErrorMessage(error)));
        }
    }
};

export const updateResource = (payload, id) => {
    return async (dispatch) => {

        dispatch(fetchStart());

        try {
            let fileData = new FormData();
            const hasPhotoPayload = Object.prototype.hasOwnProperty.call(payload, 'photos');

            if (hasPhotoPayload) {
                const photoItems = payload.photos || [];
                const existingPhotoUrls = [];

                photoItems.forEach((item) => {
                    const existingPhotoUrl = getExistingPhotoUrl(item);
                    if (existingPhotoUrl) {
                        existingPhotoUrls.push(existingPhotoUrl);
                    } else {
                        fileData.append('files', item);
                    }
                });

                fileData.append('existingPhotoUrls', JSON.stringify(existingPhotoUrls));
            }

            delete payload.photos;

            const response = await axios.put(`/fuel/${id}`, payload);
            const uploadTargetId = response && response.data && response.data._id ? response.data._id : id;

            if (hasPhotoPayload && response && response.data) {
                fileData.append('id', uploadTargetId);
                await axios.post('/fuel/upload-files-in-background', fileData, { config: { headers: { 'Content-Type': 'multipart/form-data' } } })
            }

            dispatch(fetchSuccess());
            dispatch(getUser());
            history.push('/fuel');
            dispatch(getResource());
        } catch (error) {
            console.log("Error****:", getErrorMessage(error));
            message.error(getErrorMessage(error));
            dispatch(fetchError(getErrorMessage(error)));
        }
    }
};


export const fetchResource = (id) => {
    return async (dispatch) => {

        dispatch(fetchStart());
        const { asset } = store.getState();
        // console.log(asset);
        try {
            const response = await axios.get(`/fuel/${id}`);
            // console.log(`/fuel/${id}`, response)
            dispatch(fetchSuccess());
            dispatch(fetchResourceSuccess({ data: response.data }));
        } catch (error) {
            dispatch(fetchError(error.response.data.message));
            console.log("Error****:", error.response.data.message);
        }
    }
};

export const fetchAssetFuels = (assetId, date, fuelId = '') => {
    return async (dispatch) => {
        // console.log(assetId, date, fuelId)
        dispatch(fetchStart());
        // const { asset } = store.getState();
        // console.log(asset);
        try {
            const response = await axios.post(`/fuel/asset`, { assetId, date, fuelId });
            // console.log(`/fuel/asset/${assetId}/${date}/ `, response)
            dispatch(fetchSuccess());
            dispatch(fetchAssetFuelsSuccess({ data: response.data }));
        } catch (error) {
            dispatch(fetchError(error.response.data.message));
            console.log("Error****:", error.response.data.message);
        }
    }
};

export const deleteResource = (id) => {
    return async (dispatch) => {

        dispatch(fetchStart());

        try {
            const response = await axios.delete(`/fuel/${id}`);
            // console.log('response', response)
            if (response && response.data) {
                const { fuelRemoved, deletedMeterReadingRecords } = response.data;
                notification.info({
                    message: `${fuelRemoved && fuelRemoved.deletedCount > 0 ? `Fuel Removed Successfully!, ` : ''} ${deletedMeterReadingRecords ? `${deletedMeterReadingRecords.length} Meter Reading Records Removed Successfully!` : ''}`,
                    description: `Records Removed`,
                    duration: 5,
                });
            }
            dispatch(fetchSuccess());
            dispatch(getResource());
        } catch (error) {
            message.error(getErrorMessage(error));
            dispatch(fetchError(getErrorMessage(error)));
            console.log("Error****:", getErrorMessage(error));
        }
    }
};

export const getMotorableAssetResourceSuccess = (data) => {
    return {
        type: FETCH_MOTORABLE_ASSET_SUCCESS,
        data,
    };
};

export const getMotorableAssets = (location) => {
    return async (dispatch) => {
        dispatch(fetchStart());
        try {
            const response = await axios.get(`/asset/get-motorable-assets/${location}`);
            dispatch(fetchSuccess());
            dispatch(getMotorableAssetResourceSuccess(response.data));
        } catch (error) {
            dispatch(fetchError(error.response.data.message));
            console.log("Error****:", error.response.data.message);
        }
    }
};

export const fetchMasterFilterDataSuccess = (data) => {
    return {
        type: FETCH_FUEL_FILTER_DATA_SUCCESS,
        data,
    };
};


export const fetchMasterFilterData = () => {
    return async (dispatch) => {
        dispatch(fetchStart());
        try {
            //const response = await axios.get(`/asset/get-motorable-assets/${location}`);
            const fuelTypes = await axios.get(`/fuel-type`);
            const meterUnits = await axios.get(`/interval`);
            const stockMethods = await axios.get(`/stock-method`);
            const filters = { fuelTypes, meterUnits, stockMethods };
            dispatch(fetchSuccess());
            dispatch(fetchMasterFilterDataSuccess(filters));
        } catch (error) {
            dispatch(fetchError(error.response.data.message));
            console.log("Error****:", error.response.data.message);
        }
    }
};

export const getLocationStatusDates = (location) => {
    return async (dispatch) => {
        dispatch(fetchStart());
        try {
            const response = await axios.get(`/fuel-status/available-dates/${location}`);
            dispatch(fetchSuccess());
            dispatch(fetchStatusDatesSuccess(response.data));
        } catch (error) {
            dispatch(fetchError(error.response.data.message));
            console.log("Error****:", error.response.data.message);
        }
    }
};

export const fetchStatusDatesSuccess = (data) => {
    return {
        type: FETCH_FUEL_STATUS_DATE_SUCCESS,
        data,
    };
};

export const createFuelStatusResource = (payload, redirect = false, module, subMaster = false) => {
    return async (dispatch) => {

        dispatch(fetchStart());

        try {
            const response = await axios.post(`/fuel-status`, payload);
            dispatch(fetchSuccess());
            dispatch(createResourceSuccess({ data: response.data }));
            if (!redirect) {
                message.success(`Status saved successfully!`)
                if (subMaster) {
                    dispatch(fetchSubElementFilter(module));
                } else {
                    dispatch(fetchFilter(module));
                }
            } else {
                history.push('/fuel-status');
                dispatch(getResource());
            }
        } catch (error) {
            dispatch(fetchError(error));
            console.log("Error****:", error);
        }
    }
};

export const bulkDelete = (data) => {
    return async (dispatch) => {

        dispatch(fetchStart());
        try {
            await axios.delete(`/fuel`, {
                data
            });
            dispatch(fetchSuccess());
            dispatch(getResource());
        } catch (error) {
            dispatch(fetchError(error));
            console.log("Error****:", error);
        }
    }
}

export const fuelImport = (payload) => {
    return async (dispatch) => {
        dispatch(fetchStart())
        try {
            // console.log('payload****:', payload)
            // Process the CSV file to add timestamp
            const processedFile = await processCSVWithTimestamp(payload.file)
            // console.log('processedFile****:', processedFile)

            let formData = new FormData()
            formData.append('organisation', payload.organisation)
            formData.append('files', processedFile)

            const response = await axios.post(`/fuel/bulk-fuel-import`, formData, {
                config: { headers: { 'Content-Type': 'multipart/form-data' } }
            })

            dispatch(fetchSuccess())
            if (response && response.data) {
                const { data } = response

                // Download the response as JSON file
                downloadJSONFile({
                    data: JSON.stringify(data, null, 1),
                    fileName: 'fuel-import-' + new Date().getTime() + '.json',
                    fileType: 'text/json',
                })

                // Show success alert
                message.success('Check the logs for the import status!')
            } else {
                message.error('Import failed (Also check the fuel list to verify the data). Please check your data and try again.')
            }
        } catch (error) {
            dispatch(fetchError(error))
            console.log("Error****:", error)
            message.error('Import failed. Please try again.')
        }
    }
}

const processCSVWithTimestamp = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader()

        reader.onload = (e) => {
            try {
                const csvContent = e.target.result
                const lines = csvContent.split('\n')
                const headers = lines[0].split(',')
                // console.log('headers****:', headers)

                // Find the Date column index
                const dateColumnIndex = headers.findIndex(header => header.trim() === 'Fuel Date Time')

                if (dateColumnIndex === -1) {
                    reject(new Error('Date column not found in CSV'))
                    return
                }

                // Add DateTime header
                headers.splice(dateColumnIndex + 1, 0, 'DateTime')

                // Process each data row
                const processedLines = lines.map((line, index) => {
                    if (index === 0) {
                        // Header row
                        return headers.join(',')
                    }

                    if (!line.trim()) {
                        return line // Empty line
                    }

                    const values = line.split(',')
                    const dateValue = values[dateColumnIndex]
                    // console.log('dateValue****:', dateValue)
                    if (dateValue && dateValue.trim()) {
                        // Convert date to timestamp
                        const timestamp = moment(dateValue.trim(), 'DD/MM/YY HH:mm').valueOf()
                        // console.log('timestamp****:', timestamp)
                        values.splice(dateColumnIndex + 1, 0, timestamp.toString())
                    } else {
                        values.splice(dateColumnIndex + 1, 0, '')
                    }

                    return values.join(',')
                })

                const processedCSV = processedLines.join('\n')
                const processedBlob = new Blob([processedCSV], { type: 'text/csv' })
                const processedFile = new File([processedBlob], file.name, { type: 'text/csv' })

                resolve(processedFile)
            } catch (error) {
                reject(error)
            }
        }

        reader.onerror = () => {
            reject(new Error('Failed to read file'))
        }

        reader.readAsText(file)
    })
}

// Bowser Transaction Report Actions
export const getBowserTransactionReportDataSuccess = ({ data, count }) => {
    return {
        type: FETCH_BOWSER_TRANSACTION_REPORT_DATA_SUCCESS,
        data, count
    };
};

export const getBowserFuelTransactions = (payload) => {
    return async (dispatch) => {
        // console.log('payload****:', payload)
        dispatch(fetchStart());
        try {
            const response = await axios.get('/bowser-fuel-transactions', {
                params: {
                    ...payload
                }
            });

            if (response && response.data) {
                dispatch(getBowserTransactionReportDataSuccess(response.data));
            }

            dispatch(fetchSuccess());
        } catch (error) {
            dispatch(fetchError(error.response && error.response.data && error.response.data.message || 'Failed to fetch bowser transactions'));
            console.log("Error****:", error);
        }
    };
};

export const downloadBowserFuelTransactions = (payload) => {
    return async (dispatch) => {
        dispatch(fetchStart());
        try {
            const response = await axios.get('/bowser-fuel-transactions/download', {
                params: payload
            });
            dispatch(fetchSuccess());
            return response.data;
        } catch (error) {
            dispatch(fetchError(error.response && error.response.data && error.response.data.message || 'Failed to download bowser transactions'));
            console.log("Error****:", error);
            throw error;
        }
    };
};

// Bowser Report Actions
export const getBowserReportDataSuccess = (data) => {
    return {
        type: FETCH_BOWSER_REPORT_DATA_SUCCESS,
        data
    };
};

export const getBowserReport = (payload) => {
    return async (dispatch) => {
        dispatch(fetchStart());
        try {
            const response = await axios.post('/fuel/bowser-report', payload);
            // console.log('response****:', response)
            if (response && response.data) {
                dispatch(getBowserReportDataSuccess(response.data));
            }

            dispatch(fetchSuccess());
        } catch (error) {
            dispatch(fetchError(error.response && error.response.data && error.response.data.message || 'Failed to fetch bowser report'));
            console.log("Error****:", error);
        }
    };
};

export const downloadBowserReport = (payload) => {
    return async (dispatch) => {
        dispatch(fetchStart());
        try {
            const response = await axios.get('/bowser-report/download', {
                params: payload
            });
            dispatch(fetchSuccess());
            return response.data;
        } catch (error) {
            dispatch(fetchError(error.response && error.response.data && error.response.data.message || 'Failed to download bowser report'));
            console.log("Error****:", error);
            throw error;
        }
    };
};

export const deleteBowserFuelTransaction = (id, originalPayload = {}) => {
    return async (dispatch) => {
        dispatch(fetchStart());
        try {
            await axios.delete(`/bowser-fuel-transactions/${id}`);
            dispatch(fetchSuccess());
            message.success('Bowser fuel transaction deleted successfully');
            dispatch(getBowserFuelTransactions(originalPayload));
        } catch (error) {
            dispatch(fetchError(error.response && error.response.data && error.response.data.message || 'Failed to delete bowser fuel transaction'));
            console.log("Error****:", error);
            message.error(error.response && error.response.data && error.response.data.message || 'Failed to delete bowser fuel transaction');
        }
    };
};
